import * as React from 'react'

import { EmbroideryPreview } from '@syconium/little-miss-figgy'

import { EmbroideryService } from '../../../containers/EmbroideryService'

import type { JSX } from 'react'

export const EmbroideryModalPreview: React.FC = () => {
  const { backgroundImage, previewItemsByKind, selectedFormKind } = EmbroideryService.useContainer()

  let previewItems: JSX.Element[] = []

  if (selectedFormKind) {
    previewItems = previewItemsByKind[selectedFormKind] ?? []
  } else {
    for (const [_key, value] of Object.entries(previewItemsByKind)) {
      previewItems = [...previewItems, ...value]
    }
  }
  return (
    <EmbroideryPreview
      previewItems={previewItems}
      backgroundImageSource={backgroundImage?.source}
    />
  )
}
